import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

/**
 * Renderiza el menú principal de la búsqueda avanzada en dispositivos móviles.
 *
 * Muestra las categorías disponibles (géneros, listas, niveles y formatos)
 * y notifica al componente padre cuál fue la opción seleccionada para
 * mostrar su contenido correspondiente.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.textos - Objeto con los textos e internacionalización de la interfaz.
 * @param {Function} [props.onSelect] - Función que se ejecuta al seleccionar una opción del menú.
 * @returns {JSX.Element} AdvancedSearchMobileMenu
 */
export const AdvancedSearchMobileMenu = ({
    textos,
    onSelect,
}) => {
    const handleOptionSelect = (event, optionId) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (onSelect) {
            onSelect(optionId);
        }
    };

    const options = [
        {
            id: "generos",
            label: textos?.content?.titulo1 || "Géneros",
            icon: "/img/menu/generos.png",
        },
        {
            id: "listas",
            label: textos?.content?.titulo2 || "Listas",
            icon: "/img/menu/listas.png",
        },
        {
            id: "niveles",
            label: textos?.content?.titulo3 || "Niveles",
            icon: "/img/menu/niveles.png",
        },
        // {
        //     id: "formato",
        //     label: textos?.content?.titulo4 || "Formato",
        //     icon: "/img/menu/formato.png",
        // },
    ];

    return (
        <div
            className="advanced-search-mobile-options"
            onClick={(event) => event.stopPropagation()}
        >
            {options.map((option) => (
                <button
                    key={option.id}
                    type="button"
                    onClick={(event) => handleOptionSelect(event, option.id)}
                    className="advanced-search-mobile-option"
                >
                    <div className="d-flex align-items-center w-100">
                        <div className="advanced-search-mobile-option-icon">
                            <img
                                src={option.icon}
                                alt=""
                                aria-hidden={true}
                                className="img-fluid"
                            />
                        </div>

                        <span>
                            {option.label}
                        </span>

                    </div>

                    <Icon
                        icon="tabler:chevron-right"
                        width={24}
                    />
                </button>
            ))}
        </div>
    );
};